import type { RootState } from '~/src/redux/store';

export const selectIdToken = (state: RootState) => state.idToken.idToken;
export const selectIsAuth = (state: RootState) => state.idToken.isAuth;
export const selectIdTokenLifeTime = (state: RootState) => state.idToken.idTokenLifeTime;